import React from "react";
import { motion } from "framer-motion";

const BED = "/media/showcase/music-bed-v2.mp3";

/** Looping soft music bed with smooth volume fades: to(volume, seconds), pause(), resume(), stop(). */
export function createMusic() {
  const a = new Audio(BED);
  a.loop = true; a.volume = 0; a.preload = "auto";
  let raf = 0; let target = 0; let held = false;
  const to = (vol, sec = 1.5) => {
    cancelAnimationFrame(raf);
    target = vol;
    if (vol > 0 && a.paused && !held) a.play().catch(() => {});
    const from = a.volume; const t0 = performance.now();
    const step = (now) => {
      const k = Math.min(1, (now - t0) / (sec * 1000));
      a.volume = Math.max(0, Math.min(1, from + (vol - from) * k));
      if (k < 1) raf = requestAnimationFrame(step);
      else if (vol === 0) a.pause();
    };
    raf = requestAnimationFrame(step);
  };
  return {
    to,
    pause() { held = true; cancelAnimationFrame(raf); a.pause(); },
    resume() { if (!held) return; held = false; if (target > 0) to(target, 0.6); },
    stop() { cancelAnimationFrame(raf); a.pause(); },
  };
}

export function IntroCard() {
  return (
    <div data-testid="show-intro" className="absolute inset-0 bg-[#030408] flex items-center justify-center">
      <motion.div className="absolute w-[60vmin] h-[60vmin] rounded-full" style={{ background: "radial-gradient(circle, rgba(212,160,23,0.16), transparent 65%)", filter: "blur(40px)" }}
        initial={{ opacity: 0, scale: 0.3 }} animate={{ opacity: 1, scale: 1.1 }} exit={{ opacity: 0, scale: 0.3 }} transition={{ duration: 3.4, ease: "easeInOut" }} />
      <motion.img src="/tea-medallion.png" alt="The Exchange Alliance" data-testid="show-intro-logo" className="relative w-[34vmin] h-[34vmin] object-contain drop-shadow-[0_0_40px_rgba(212,160,23,0.25)]"
        initial={{ opacity: 0, scale: 0.35 }} animate={{ opacity: 1, scale: 1, transition: { scale: { duration: 3.4, ease: [0.45, 0, 0.25, 1] }, opacity: { duration: 1.2 } } }}
        exit={{ opacity: 0, scale: 0.35, transition: { duration: 1.6, ease: [0.55, 0, 0.75, 0.4] } }} />
    </div>
  );
}
